import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { EntityLink } from "~/components/entity-link";

export const StyledCoverEntityLink = styled(EntityLink)`
  inline-size: 100%;
  block-size: 100%;
`;

export const StyledTitleEntityLink = styled(EntityLink)`
  display: -webkit-box;

  inline-size: 100%;

  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

export const Header = styled.div`
  grid-area: header;
`;

export const Content = styled.div`
  grid-area: content;

  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: flex-start;

  padding-block: 12px 16px;
  padding-inline: 15px;

  font-weight: 900;
  font-size: 18px;
  font-family: ${fontRobotoCondensed};
  line-height: 24px;

  overflow: hidden;
`;

export const Container = styled.div`
  display: grid;
  grid:
    "header" 144px
    "content" 194px
    / 1fr;

  border: 1px solid #e5e5e5;
  border-radius: 4px;

  overflow: hidden;
`;
